export default function NotificationPopoverListItemIcon({ notification }) {
  const getIconColorClass = (notification) => {
    switch (notification.iconColor) {
      case 'blue':
        return 'text-blue-500';
      case 'green':
        return 'text-green-500';
      case 'red':
        return 'text-red-500';
      case 'yellow':
        return 'text-yellow-500';
      case 'purple':
        return 'text-purple-500';
      case 'pink':
        return 'text-pink-500';
      case 'gray':
        return 'text-gray-500';
      case 'indigo':
        return 'text-indigo-500';
      case 'teal':
        return 'text-teal-500';
      default:
        return 'text-orange-500';
    }
  };

  return (
    <i
      className={[
        'fa text-base',
        notification.icon,
        getIconColorClass(notification),
      ].join(' ')}
    />
  );
}
